import classNames from 'classnames';
import { memo, type CSSProperties } from 'react';

import styles from '../../styles/partials/loading-bar.module.css';

interface LoadingBarProps {
    loading?: boolean;
    loaded?: boolean;
    color?: string | null;
    className?: string | null;
    barClassName?: string | null;
}

function LoadingBar({
    loading = false,
    loaded = false,
    color = null,
    className = null,
    barClassName = null,
}: LoadingBarProps) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.loading]: loading,
                    [styles.loaded]: loaded,
                },
                className,
            ])}
        >
            <div
                className={classNames([styles.bar, barClassName])}
                style={
                    {
                        backgroundColor: color,
                    } as CSSProperties
                }
            />
        </div>
    );
}

export default memo(LoadingBar);
